// Stand-in for network latency so the loading states in each stage are real
// UX, not decoration. Every mock module goes through this.

export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
